import SEOHead from '../components/SEOHead';
import { useLanguage } from '../store/LanguageContext';

export default function TermsPage() {
  const { lang } = useLanguage();

  return (
    <>
      <SEOHead page="terms" />
      <div className="min-h-screen bg-[#faf7f3]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <h1 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-8" style={{ fontFamily: 'Playfair Display' }}>
            {lang === 'fr' ? 'Conditions Générales de Vente' : 'Algemene Voorwaarden'}
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            {lang === 'fr' ? 'Dernière mise à jour : 4 mars 2026' : 'Laatst bijgewerkt: 4 maart 2026'}
          </p>

          <div className="prose prose-gray max-w-none space-y-8 text-[#1a1a1a]">
            {lang === 'fr' ? (
              <>
                <section>
                  <h2 className="text-xl font-bold mb-3">1. Identification de l'entreprise</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Gevelsteenbedrijf.be est une entreprise belge spécialisée dans la vente de plaquettes de parement premium.
                    Siège social : Anvers, Belgique. E-mail : info@gevelsteenbedrijf.be. Téléphone : +32 (0)3 123 45 67.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">2. Champ d'application</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Les présentes conditions générales s'appliquent à toutes les offres, commandes et contrats conclus via le site web gevelsteenbedrijf.be. En passant commande, le client accepte les présentes conditions. Toute dérogation doit faire l'objet d'un accord écrit préalable.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">3. Prix et paiement</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Tous les prix sont indiqués en euros (€), hors TVA (21%), sauf mention contraire. Les prix sont valables au moment de la commande. Le paiement s'effectue conformément aux conditions mentionnées sur la facture. En cas de retard de paiement, des intérêts de retard seront appliqués conformément à la législation belge.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">4. Livraison</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Les délais de livraison sont indicatifs et non contractuels. La livraison est effectuée par un distributeur local dans votre région. Le risque est transféré à l'acheteur au moment de la livraison. Toute réclamation concernant la livraison doit être signalée dans les 48 heures.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">5. Droit de rétractation</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Conformément au Code de droit économique belge (Livre VI), le consommateur dispose d'un délai de 14 jours calendaires pour exercer son droit de rétractation, sans justification. Ce droit ne s'applique pas aux produits sur mesure. Les frais de retour sont à la charge du consommateur.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">6. Garantie</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Nos produits bénéficient d'une garantie de 10 ans couvrant les défauts de fabrication. La garantie ne couvre pas les dommages résultant d'une installation incorrecte, d'une utilisation inappropriée ou de l'usure normale. Conformément à la loi belge, le consommateur bénéficie d'une garantie légale de 2 ans.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">7. Protection des données personnelles</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Nous traitons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation belge en matière de vie privée. Conformément aux modifications apportées par l'Omnibus Digital (Directive 2024/XX/UE), nous veillons à ce que le traitement des données soit transparent et minimisé. Consultez notre politique de cookies pour plus d'informations.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">8. Responsabilité</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Notre responsabilité est limitée au montant de la commande. Nous ne sommes pas responsables des dommages indirects, des pertes de profit ou des dommages résultant d'une installation incorrecte.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">9. Litiges</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Les présentes conditions sont régies par le droit belge. Tout litige sera soumis aux tribunaux compétents d'Anvers. Le consommateur peut également s'adresser à la plateforme européenne de règlement en ligne des litiges : https://ec.europa.eu/consumers/odr.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">11. Contact</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Pour toute question concernant ces conditions, veuillez nous contacter à info@gevelsteenbedrijf.be ou au +32 (0)3 123 45 67.
                  </p>
                </section>
              </>
            ) : (
              <>
                <section>
                  <h2 className="text-xl font-bold mb-3">1. Identificatie van het bedrijf</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Gevelsteenbedrijf.be is een Belgisch bedrijf gespecialiseerd in de verkoop van premium baksteenstrips.
                    Maatschappelijke zetel: Antwerpen, België. E-mail: info@gevelsteenbedrijf.be. Telefoon: +32 (0)3 123 45 67.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">2. Toepassingsgebied</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, bestellingen en overeenkomsten afgesloten via de website gevelsteenbedrijf.be. Door een bestelling te plaatsen, aanvaardt de klant deze voorwaarden. Afwijkingen zijn enkel geldig mits voorafgaand schriftelijk akkoord.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">3. Prijzen en betaling</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Alle prijzen zijn in euro (€), exclusief BTW (21%), tenzij anders vermeld. Prijzen zijn geldig op het moment van bestelling. Betaling geschiedt conform de voorwaarden vermeld op de factuur. Bij laattijdige betaling worden nalatigheidsintresten aangerekend overeenkomstig de Belgische wetgeving.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">4. Levering</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Leveringstermijnen zijn indicatief en niet bindend. Levering geschiedt via een lokale verdeler in uw regio. Het risico gaat over op de koper bij levering. Klachten over de levering dienen binnen 48 uur te worden gemeld.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">5. Herroepingsrecht</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Overeenkomstig het Belgisch Wetboek van economisch recht (Boek VI) beschikt de consument over een termijn van 14 kalenderdagen om zijn herroepingsrecht uit te oefenen, zonder opgave van reden. Dit recht is niet van toepassing op maatwerkproducten. De retourkosten zijn ten laste van de consument.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">6. Garantie</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Onze producten genieten een garantie van 10 jaar op fabricagefouten. De garantie dekt geen schade als gevolg van onjuiste installatie, oneigenlijk gebruik of normale slijtage. Overeenkomstig de Belgische wet geniet de consument een wettelijke garantie van 2 jaar.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">7. Bescherming van persoonsgegevens</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Wij verwerken uw persoonsgegevens conform de Algemene Verordening Gegevensbescherming (AVG/GDPR) en de Belgische privacywetgeving. Conform de wijzigingen van de Digitale Omnibus (Richtlijn 2024/XX/EU) zorgen wij voor transparante en geminimaliseerde gegevensverwerking. Raadpleeg ons cookiebeleid voor meer informatie.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">8. Aansprakelijkheid</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Onze aansprakelijkheid is beperkt tot het bedrag van de bestelling. Wij zijn niet aansprakelijk voor indirecte schade, winstderving of schade als gevolg van onjuiste installatie.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">9. Taal van offertes en documenten</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Offertes, orderbevestigingen en facturen worden opgemaakt in de taal die u
                    zelf op de website heeft gekozen (Nederlands of Frans). Die taalkeuze is uw
                    eigen beslissing en doet geen afbreuk aan de toepasselijkheid van deze
                    voorwaarden. Bij interpretatieverschillen tussen taalversies geldt de
                    Nederlandstalige versie van deze voorwaarden.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">10. Geschillen</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Deze voorwaarden worden beheerst door het Belgisch recht. Elk geschil wordt voorgelegd aan de bevoegde rechtbanken van Antwerpen. De consument kan zich ook wenden tot het Europees platform voor onlinegeschillenbeslechting: https://ec.europa.eu/consumers/odr.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">11. Contact</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Voor vragen over deze voorwaarden kunt u ons contacteren via info@gevelsteenbedrijf.be of +32 (0)3 123 45 67.
                  </p>
                </section>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
